import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { Grid } from "@material-ui/core";
import { Header, Footer, FormForgot } from "~/components/blocks";
import { Breadcrumb } from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import isMobile from "~/hooks/isMobile";
import * as S from "./styles";

export default function ForgotPass() {
  const mobile = isMobile();

  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },
    {
      text: "Esqueci minha senha",
      link: "/esqueci-minha-senha",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Esqueci minha senha</title>
      </Helmet>

      <Header />

      <HeroBanner />

      <Breadcrumb navBreadcrumb={navBreadcrumb} />

      <S.StyledMotionDiv>
        <div className="div">
          <motion.div
            variants={animations}
            className="single"
            initial="exit"
            animate="enter"
            exit="exit"
          >
            <Grid
              container
              justifyContent="space-between"
              align={mobile ? "center" : "initial"}
            >
              <FormForgot />
            </Grid>
          </motion.div>
        </div>
      </S.StyledMotionDiv>
      <Footer />
    </>
  );
}
